import './StatisticDelta.scss';
import classNames from 'classnames';
import React from 'react';

function getDeltaChange(change: number, isPercent?: boolean, precision?: number): string {
	const sign = change > 0 ? '+' : '';
	const percent = isPercent ? '%' : '';

	return `${sign}${change.toFixed(precision)}${percent}`;
}

export interface StatisticDeltaProps {
	change: number;
	isPercent?: boolean;
	precision?: number;
}

export const StatisticDelta: React.FC<StatisticDeltaProps> = ({ change, isPercent, precision }) => {
	if (change === 0) {
		return null;
	}

	const signClassName = change > 0 ? 'positive' : 'negative';
	const delta = getDeltaChange(change, isPercent, precision);

	return <span className={ classNames('statistic-delta', signClassName) }>{ delta }</span>;
};
